import { useEffect, useState } from "react";

const read = (key, fallback) => {
  try { return localStorage.getItem(key) ?? fallback; } catch { return fallback; }
};

const write = (key, value) => {
  try { localStorage.setItem(key, value); } catch { /* ignore quota / private mode */ }
};

export function useSetting(key, fallback) {
  const [value, setValue] = useState(() => read(key, fallback));
  useEffect(() => { write(key, value); }, [key, value]);
  return [value, setValue];
}

export function useTheme() {
  const [theme, setTheme] = useSetting("placement:theme", "ivory");
  useEffect(() => {
    document.documentElement.dataset.theme = theme;
  }, [theme]);
  return [theme, setTheme];
}
